export const CURRENCY_RESPONSE_ARRAY_KEYS = [
  "data",
  "Data",
  "currencies",
  "Currencies",
  "items",
  "Items",
  "rows",
  "Rows",
  "list",
  "List",
  "result",
  "Result",
  "body",
  "Body",
  "records",
  "Records",
  "content",
  "Content",
  "payload",
  "Payload",
  "results",
  "Results"
];

/** Pull the first non-empty array of objects from typical API wrappers (nested data/Data, etc.). */
export function firstCurrencyArrayDeep(obj, depth = 0) {
  if (obj == null || depth > 8) return null;
  if (Array.isArray(obj)) {
    return obj.length > 0 ? obj : null;
  }
  if (typeof obj !== "object") return null;
  for (const k of CURRENCY_RESPONSE_ARRAY_KEYS) {
    if (Object.prototype.hasOwnProperty.call(obj, k)) {
      const found = firstCurrencyArrayDeep(obj[k], depth + 1);
      if (found) return found;
    }
  }
  return null;
}

export function currencyRowsFromResponseData(responseData) {
  if (responseData == null) return [];
  if (Array.isArray(responseData)) return responseData;
  const nested = firstCurrencyArrayDeep(responseData);
  if (nested) return nested;
  if (
    typeof responseData === "object" &&
    (responseData.Currency_Id != null ||
      responseData.currency_id != null ||
      responseData.Currency_Code != null ||
      responseData.currency_code != null ||
      responseData.Currency_Name != null ||
      responseData.currency_name != null)
  ) {
    return [responseData];
  }
  return [];
}

export function normalizeCurrencyRow(c) {
  const row = c && typeof c === "object" ? c.currency || c.Currency || c : c;
  if (!row || typeof row !== "object") return null;
  const id =
    row.Currency_Id ??
    row.currency_id ??
    row.CurrencyID ??
    row.CurrencyId ??
    row.Id ??
    row.id;
  const name =
    row.Currency_Name ??
    row.currency_name ??
    row.Name ??
    row.name ??
    "";
  const code =
    row.Currency_Code ??
    row.currency_code ??
    row.Code ??
    row.code ??
    "";
  const symbol =
    row.Currency_Symbol ??
    row.currency_symbol ??
    row.Symbol ??
    row.symbol ??
    "";
  if (id == null || String(id).trim() === "") return null;
  return { id, name, code, symbol };
}
